import { Component, ViewChild } from '@angular/core';
import { CommonApiService } from 'src/app/API/commonapi.service.';
import { PageHeaderComponent } from 'src/app/Core/pageheader.component';
import { DecimalPipe, DatePipe } from '@angular/common';
import { AppComponent } from 'src/app/app.component';
import { WPApiService } from 'src/app/API/wpapi.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TableHeadsService } from 'src/app/Core/tableheads.service';
import { URLDialog } from 'src/app/Core/Shared/URLDialog/URLDialog';
import { ConfirmationDialog } from 'src/app/Core/ConfirmationDialog';
import { Globals } from "src/app/globals";
import { InvApiService } from 'src/app/API/invapi.service';
import { ImageViewerDialog } from 'src/app/Core/Shared/ImageViewerDialog/ImageViewerDialog';
@Component({
  // moduleId: module.id,
  selector: 'BioPureHX2Document',
  templateUrl: 'BioPureHX2Document.component.html',
  styleUrls: ['BioPureHX2Document.component.css']
})

export class BioPureHX2DocumentComponent {
  title =  'BioPure HX2 Documents';
  urlDialogRef: MatDialogRef<URLDialog>;
  constructor(
    private datePipe: DatePipe,
    private decimalPipe: DecimalPipe,
  private router: Router,
  private wpapi: WPApiService,
  private dataGridService: TableHeadsService,
  private commonapi : CommonApiService,
  public dialog: MatDialog,
  private invapi: InvApiService
) {
  this.page.pageNumber = 0;
  this.page.size = 25;
}

@ViewChild(PageHeaderComponent, { static: false }) pageheader: PageHeaderComponent;

tableHeaders;
page = new Page();
rows ;
defaultSort;

currentPageNumber = 1;
sortExpression = 'attachmentName';
sortDirection = 'ASC';
pageSize = 25;
ShowSearch = false;
searchText = 'Search Records';
isPageLoaded = false;

extension: string;

  // roSystemDocuments = [
  //   { name: 'HX2 Compressor Inlet Filter Maintenance', file: 'HX2 Compressor Inlet Filter Maintenance.pdf' },
  //   { name: 'HX2 Compressor Outlet Filter Maintenance', file: 'HX2 Compressor Outlet Filter Maintenance.pdf' },
  //   { name: 'HX2 Membrane and Loop Cleaning and Sanitization', file: 'HX2 Membrane and Loop Cleaning and Sanitization.pdf' },
  //   { name: 'HX2 Membrane Fouling and Cleaning Sanitization Frequency', file: 'HX2 Membrane Fouling and Cleaning Sanitization Frequency.pdf' },
  //   { name: 'HX2 Purging the Compressor System of Condensate', file: 'HX2 Compressor Inlet Filter Maintenance.pdf' },
  //   { name: 'HX2 Pre Loop Filter Change', file: 'HX2 Pre Loop Filter Change.pdf' },
  //   { name: 'HX2 Relief Valve Test', file: 'HX2 Relief Valve Test.pdf' },
  //   { name: 'HX2 Service Schedule', file: 'HX2 Service Schedule.pdf' },
  //   { name: 'HX2 Spare Parts', file: 'HX2 Spare Parts.pdf' },
  //   { name: 'HX2 Status Messages', file: 'HX2 Status Messages.pdf' },
  //   { name: 'HX2 Troubleshooting', file: 'HX2 Troubleshooting.pdf' },
  //   { name: 'HX2 Pre Filter Change', file: 'HX2 Pre Filter Change.pdf' },
  // ];

  roSystemDocuments = [];

ngOnInit() {

      this.dataGridService.clearHeader();
      this.dataGridService.addHeader('#', 'Id', '5');
      this.dataGridService.addHeader('Document Name', 'attachmentName', '90');
      this.dataGridService.addHeader('Delete', '', '5');
      this.tableHeaders = this.dataGridService.setTableHeaders();
      this.defaultSort = this.dataGridService.setDefaultSort('attachmentName', false);
      this.getHX2Documents();
}

setSortIndicator = function (column) {
  //  console.log(this.dataGridService.setSortIndicator(column, this.defaultSort));
    return this.dataGridService.setSortIndicator(column, this.defaultSort);
};


setPage() {
  if(this.currentPageNumber != this.page.pageNumber)
  {
  this.currentPageNumber = this.page.pageNumber;
  if (this.isPageLoaded === true) {
//  console.log('setpage');
  // this.executeNurseCheckSearch();
  }
}
}
_onRowClick(row) {
    // this.router.navigate([this.AddUrl], { queryParams: { id: row} });
}

  RouteClick(value) {
    this.router.navigate([value]);
  }

  AttachmentError(Error) {

    AppComponent.addAlert(Error, 'error');
  }

  openURLDialog(FileName, URL): void {
    this.urlDialogRef = this.dialog.open(URLDialog, {
      disableClose: true,
      position: { right: '0', top: '0' },
      height: '100%',
    });

    this.urlDialogRef.componentInstance.URL = URL;
    this.urlDialogRef.componentInstance.dialogRef.updateSize('80%', '100%');
    this.urlDialogRef.componentInstance.PageTitle = FileName;
    this.urlDialogRef.afterClosed().subscribe(result => {
      this.urlDialogRef = null;
    });
  }

    openImageDialog(container, FileName, FileLabel): void {
      // const obj = { originalfilename: FileName, containerName: 'uploads' }; // No need for JSON.stringify if using HttpClient with JSON
      this.invapi.GetSasUrl(container, FileName).subscribe(response => {
        const sasUrl = response.url; // This is the signed blob URL from API
        this.extension = FileName.split('.').pop()?.toLowerCase();
    
        if (['png', 'jpg', 'gif', 'jpeg'].includes(this.extension)) {
          const dialogRef = this.dialog.open(ImageViewerDialog, {
            position: { right: '0', top: '0' },
            height: '100%',
            width: '70%',
            data: { imgURL: sasUrl, title: FileName }
          });
    
          dialogRef.afterClosed().subscribe(() => {
            // console.log('Image dialog was closed');
          });
        } else {
          this.urlDialogRef = this.dialog.open(URLDialog, {
            disableClose: true,
            position: { right: '0', top: '0' },
            height: '100%',
          });
    
          this.urlDialogRef.componentInstance.URL = sasUrl; // use SAS URL here too
          this.urlDialogRef.componentInstance.dialogRef.updateSize('80%', '100%');
          this.urlDialogRef.componentInstance.PageTitle = FileLabel;
          this.urlDialogRef.afterClosed().subscribe(() => {
            this.urlDialogRef = null;
          });
        }
      }, error => {
        console.error('Failed to fetch SAS URL for', FileName, error);
      });
    }
  
  setCategorywithFileName(fileName: string): string {
    return  fileName;
  }

  SetAttachmentUrl(fileName) {
    return Globals.AttachmentUrl + '/HX2DOCUMENTS/' + fileName;
  }

  getHX2Documents() {
    const documentCreate = this.prepareCreateViewModel();
     this.invapi.GetHX2DocumentsList(documentCreate).subscribe(pagedData  => {
        const hx2Docs = pagedData.filter(item => {
        const fileName = item.fileName.split('/').pop();  
        return fileName.startsWith('HX2');
      });
      this.roSystemDocuments = hx2Docs;
      AppComponent.HideLoader();
    },
    error => {
          AppComponent.addAlert(error.message, 'error');
          AppComponent.HideLoader();
      }
    );
  }

    prepareCreateViewModel() {
      const documentCreate = <any>{};
      documentCreate.containerCategoryName = 'ro_systems';
      documentCreate.isStatic = 1;
      return documentCreate;
    }
}

export class Page {
  // The number of elements in the page
  // tslint:disable-next-line:no-inferrable-types
  size: number = 25;
  // The total number of elements
  // tslint:disable-next-line:no-inferrable-types
  totalElements: number = 0;
  //  The total number of pages
  // tslint:disable-next-line:no-inferrable-types
  totalPages: number = 0;
  // The current page number
  // tslint:disable-next-line:no-inferrable-types
  pageNumber: number = 0;
}
